import axios from "axios";

export default axios.create({
  baseURL: "https://api.qistar.sa/api/",
});
